import { useEffect, useRef } from 'react'
import { usePageTitle } from '../../utils/usePageTitle'
import { useLogout } from './useAuth'

export const LogoutPage = () => {
	const { logout } = useLogout()
	const hasInitiatedLogout = useRef(false)

	usePageTitle()

	useEffect(() => {
		// Prevent multiple logout calls even if component re-renders
		if (!hasInitiatedLogout.current) {
			hasInitiatedLogout.current = true
			// Trigger logout mutation - navigation and cleanup handled in useAuth
			logout.mutate()
		}
	}, [logout])

	return null
}
